import type { Role } from '@/domain/model/Role';

export const roleChipKind = (role: Role) => {
  if (role === 'SUPER_ADMIN') return 'warn' as const;
  if (role === 'ADMIN') return 'accent' as const;
  return 'good' as const;
};
